import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=3a97e230&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=3a97e230&prod&scoped=true&lang=css"
import style1 from "./DateInput.vue?vue&type=style&index=1&id=3a97e230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97e230",
  null
  
)

export default component.exports